export default "__VITE_ASSET__CDSPCj8E__"